import { useContext } from "react";
import { AuthContext } from "../../../../../context/context";
import { InfoTableHighRisk, SectionSelector } from "./components";

export const AltaRiesgo14 = ({ setMessage, setShowMessage, showButtons }) => {
  const { persons, onlyApprove } = useContext(AuthContext);
  if (!showButtons.multiTable)
    return (
      <SectionSelector
        setMessage={setMessage}
        setShowMessage={setShowMessage}
      />
    );
  return (
    <InfoTableHighRisk
      rows={persons.length > 0 ? persons : onlyApprove}
      title="Asegurados Guardados"
    />
  );
};
